
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class OrderInstallmentReportGrid extends Serenity.EntityGrid<OrderInstallmentReportRow, any> {
        protected getColumnsKey() { return OrderInstallmentReportColumns.columnsKey; }
        protected getDialogType() { return OrderInstallmentReportDialog; }
        protected getIdProperty() { return OrderInstallmentReportRow.idProperty; }
        protected getInsertPermission() { return OrderInstallmentReportRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderInstallmentReportRow.localTextPrefix; }
        protected getService() { return OrderInstallmentReportService.baseUrl; }

      
        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(0, 3);
            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                title: 'Export',
                service: OrderInstallmentReportService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));


            return buttons;

        }
    }
}